import '../../../assets/markdown.css'

import React from 'react'

import { DescriptionQuestionRender } from './DescriptionQuestionRender'
import MarkdownQuestionRenderer from './MarkdownQuestionRenderer'

function SummaryQuestion({ question, answer }) {
  return (answer?.answer_raw || question.text || '').includes('<p>') ? (
    <DescriptionQuestionRender
      {...{
        question_id: question.id,
        answer_id: answer?.id,
        value: answer?.answer_raw || question.text,
      }}
    />
  ) : (
    <MarkdownQuestionRenderer value={answer?.answer_raw || question.text} />
  )
}

export default SummaryQuestion
